/**
 * Project page, the next shop on the street — the way on, standing on its
 * own stretch of road. The markup is the server's
 * (templates/site/sections/project/next.html.twig).
 *
 * @module sections/project/next
 */

import { REDUCED_MOTION } from '../../config.js';
import { gsap } from '../../lib/gsap.js';

/**
 * The next shop rises into place.
 *
 * @param {HTMLElement} section
 */
export function animate(section) {
    const shop = section.querySelector('.case-next__shop > *');

    if (REDUCED_MOTION || !shop) {
        return;
    }

    gsap.from(shop, {
        yPercent: 18,
        opacity: 0,
        duration: 1.1,
        scrollTrigger: { trigger: shop, start: 'top 90%', once: true },
    });
}
